export default __webpack_public_path__ + "static/media/sideimg3.af81ccd5.jpg";